import * as React from "react";
import { ChakraProvider, theme } from "@chakra-ui/react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import Dashboard from "./views/Legacy/Dashboard";
import AutoPlantInfo from "./views/Legacy/AutoPlantInfo";
import Login from "./views/Authentication/Login";
import SignUp from "./views/Authentication/SignUp";
import PasswordResetConfirm from "./views/Authentication/PasswordResetConfirm";
import RequestPasswordResetView from "./views/Authentication/RequestPasswordResetView";
import NotImplemented from "./components/NotImplemented";
import TemaQuiz from "./views/TemaQuiz";
import DraginoSelect from "./views/Legacy/DraginoSelect";
import DraginoViewer from "./views/Legacy/DraginoViewer";
import DeviceOverview from "./views/DeviceOverview";
import DeviceViewer from "./views/DeviceViewer";
import TrackerViewer from "./views/TrackerViewer";
import DeviceMapView from "./views/DeviceMapView";
import AddDeviceView from "./views/internal/AddDeviceView";
import AddView from "./views/Addition/AddView";
import EditDeviceView from "./views/EditDeviceView";
import DeviceSettingsView from "./views/DeviceSettingsView";
import ManualAdd from "./views/Addition/ManualAdd";
import ManualOverview from "./views/Addition/ManualOverview";
import SettingsView from "./views/SettingsView";
import AddTrainingDataView from "./views/internal/AddTrainingDataView";
import GatewaysView from "./views/internal/GatewaysView";
import GatewayDevicesView from "./views/internal/GatewayDevicesView";
import AutoplantView from "./views/internal/AutoplantView";
import PrivateRoute from "./utils/PrivateRoute";
import MapSelector from "./views/MapSelector";
import AddModifyField from "./views/Fields/AddModifyField";
import Fields from "./views/Fields/Fields";
import AdditionalInformationWidget from "./components/FieldComponents.tsx/AdditionalInformationWidget";
import AlarmsView from "./views/AlarmsView";
import AddEditAlarm from "./views/AddEditAlarmView";
import IrrigationOverview from "./views/Irrigation/IrrigationOverview";
import IrrigationController from "./views/Irrigation/IrrigationController";
import AddFieldAlarmView from "./views/AddFieldAlarmView";
import GatewaysViewPublic from "./views/gateways/GatewaysViewPublic";
import ProfileView from "./views/Profile/ProfileView";
import ChangePasswordWidget from "./views/Authentication/ChangePasswordWidget";
import GatewayDevicesViewPublic from "./views/gateways/GatewayDevicesViewPublic";
import DiseasePredictionView from "./views/DiseasePredictionView";
import GDDView from "./views/GDDView";
import WeatherStationView from "./views/WeatherStation/WeatherStationView";
import WeatherStationDetailView from "./views/WeatherStation/WeatherStationDetailView";
import ValveViewer from "./views/ValveViews/ValveViewer";
import FieldsNew from "./views/Fields/FieldsNew";
import FieldNewView from "./views/Fields/FieldNewView";
import AlarmsNewOverview from "./views/AlarmsNewOverview";
import FieldSatelliteView from "./views/FieldSatelliteView";
import DeviceOverviewInternal from "./views/internal/DeviceOverviewInternal";
import MonitoringView from "./views/MonitoringView";
import GatewayDetailView from "./views/GatewayDetailView";
import CompareView from "./views/CompareView";

export const App = () => (
  <ChakraProvider theme={theme}>
    <Router>
      <AuthProvider>
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route path="/map" element={<DeviceMapView />} />
            <Route path="/autoplant" element={<Dashboard />} />
            <Route path="/plant-info" element={<AutoPlantInfo />} />
            <Route path="/profile" element={<ProfileView />} />
            <Route path="/profile/password-change" element={<ChangePasswordWidget />} />
            <Route path="/explore" element={<NotImplemented />} />
            <Route path="/favourites" element={<NotImplemented />} />
            <Route path="/dragino/:id" element={<DraginoViewer />} />
            <Route path="/dragino" element={<DraginoSelect />} />
            <Route path="/devices/:id/edit/" element={<EditDeviceView />} />
            <Route path="/devices/:id/settings" element={<DeviceSettingsView />} />
            <Route path="/devices/:id/compare" element={<CompareView />} />
            <Route path="/devices/:id" element={<DeviceViewer />} />
            <Route path="/tracker/:id" element={<TrackerViewer />} />
            <Route path="/devices" element={<DeviceOverview />} />
            <Route path="/internal/devices" element={<DeviceOverviewInternal />} />
            <Route path="/internal/add-device" element={<AddDeviceView />} />
            <Route path="/add-device" element={<AddView />} />
            <Route path="/add-device/manual" element={<ManualAdd />} />
            <Route path="/add-device/manual/overview/:label_code" element={<ManualOverview />} />
            <Route path="/settings" element={<SettingsView />} />
            <Route path="/internal/add-training-data/" element={<AddTrainingDataView />} />
            <Route path="/internal/gateways/" element={<GatewaysView />} />
            <Route path="/gateways/" element={<GatewaysViewPublic />} />
            <Route path="/internal/gateway-devices/:id" element={<GatewayDevicesView />} />
            <Route path="/gateways/gateway-devices/:id" element={<GatewayDevicesViewPublic />} />
            <Route path="/internal/autoplants/" element={<AutoplantView />} />
            <Route path="/settings" element={<NotImplemented />} />
            <Route path="/map-selector" element={<MapSelector />} />
            <Route path="/fields/add" element={<AddModifyField />} />
            <Route path="/fields/edit/:id" element={<AddModifyField />} />

            <Route path="/fields/alarms/:fieldId" element={<AlarmsNewOverview />} />
            <Route path="/" element={<FieldsNew />} />
            <Route path="/fields" element={<FieldsNew />} />
            <Route path="/fields/view/:id" element={<FieldNewView />} />
            <Route path="/field/:id/additional-info" element={<AdditionalInformationWidget />} />
            <Route path="/fields/satellite/:id" element={<FieldSatelliteView />} />

            <Route path="/internal/alarms" element={<AlarmsView />} />
            <Route path="/alarms" element={<AlarmsNewOverview />} />
            <Route path="/alarms/add" element={<AddEditAlarm />} />
            <Route path="/alarms/edit/:id" element={<AddEditAlarm />} />
            <Route path="/alarms/alarm-field-add/:id" element={<AddFieldAlarmView />} />
            <Route path="/alarms/alarm-field-edit/:id" element={<AddFieldAlarmView />}></Route>
            <Route path="/irrigation" element={<IrrigationOverview />} />
            <Route path="/irrigation/:id" element={<IrrigationController />} />
            <Route path="/disease-prediction" element={<DiseasePredictionView />} />
            <Route path="/gdd" element={<GDDView />} />
            <Route path="/weather-station" element={<WeatherStationView />} />
            <Route path="/weather-station/:id" element={<WeatherStationDetailView />} />
            <Route path="/valve-view/:id" element={<ValveViewer />}></Route>
            <Route path="/monitoring" element={<MonitoringView />}></Route>
            <Route path="/monitoring/gateway/:id" element={<GatewayDetailView />}></Route>
          </Route>
          <Route path="*" element={<h1>404</h1>} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signup/:activation_key" element={<SignUp />} />
          <Route path="/password-reset-confirm/:uid/:token" element={<PasswordResetConfirm />} />
          <Route path="/request-password-reset" element={<RequestPasswordResetView />} />
          <Route path="/tema-quiz" element={<TemaQuiz />} />
        </Routes>
      </AuthProvider>
    </Router>
  </ChakraProvider>
);
